"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tableXsmallComponents = void 0;
var _StyledButton = _interopRequireDefault(require("../../Button/StyledButton"));
var _StyledDatePicker = require("../../DatePicker/StyledDatePicker");
var _StyledInputHoc = require("../../Form/styled/StyledInputHoc");
var _StyledIcon = _interopRequireDefault(require("../../Icon/StyledIcon"));
var _StyledNumericInput = require("../../NumberInput/StyledNumericInput");
var _StyledSelect = require("../../Select/StyledSelect");
var _StyledTableHeader = require("../../TableHeader/StyledTableHeader");
var _StyledTextInput = require("../../TextInput/StyledTextInput");
var _ykbStyledComponents = require("../../ykb-styled-components");
var xSmallButton = (0, _ykbStyledComponents.css)(["", "{&.table-xs{padding:", ";height:", ";font-size:", ";&.icon-only{padding:", " !important;}", "{font-size:", ";}}}"], _StyledButton.default, function (props) {
  return props.theme.button.size.xsmall.padding;
}, function (props) {
  return props.theme.button.size.xsmall.height;
}, function (props) {
  return props.theme.button.size.xsmall.fontSize;
}, function (props) {
  return props.theme.button.size.xsmall.paddingWithIcons;
}, _StyledIcon.default, function (props) {
  return props.theme.button.size.xsmall.iconSize;
});
var xSmallTableHeaderGhostButton = (0, _ykbStyledComponents.css)(["", "{&.table-xs{", "{font-size:", ";}", "{line-height:", ";}}}"], _StyledButton.default, _StyledTableHeader.StyledGhostIcon, function (props) {
  return props.theme.button.size.xsmall.iconSize;
}, _StyledTableHeader.StyledGhostText, function (props) {
  return props.theme.button.size.xsmall.iconSize;
});
var xSmallInput = (0, _ykbStyledComponents.css)(["", "{&.table-xs{height:", ";font-size:", ";line-height:calc( ", " + 2 * ", " );}}", "{&.table-xs{", "{font-size:", ";", "{height:", ";padding:", ";font-size:", ";}}}}"], _StyledTextInput.StyledInput, function (props) {
  return props.theme.button.size.xsmall.height;
}, function (props) {
  return props.theme.button.size.xsmall.fontSize;
}, function (props) {
  return props.theme.button.size.xsmall.height;
}, function (props) {
  return props.theme.button.size.xsmall.borderWidth;
}, _StyledTextInput.StyledInputGroup, _StyledTextInput.StyledInputAddon, function (props) {
  return props.theme.button.size.xsmall.fontSize;
}, _StyledButton.default, function (props) {
  return props.theme.button.size.xsmall.height;
}, function (props) {
  return props.theme.button.size.xsmall.padding;
}, function (props) {
  return props.theme.button.size.xsmall.fontSize;
});
var xSmallSelect = (0, _ykbStyledComponents.css)(["", "{&.table-xs{", "{min-height:", ";", "{margin-top:2px;height:calc(", " - 5px);line-height:calc( ", " - 5px - 2px );}}", "{line-height:calc( ", " - 2 * ", " );}", "{top:calc(", " / 2);font-size:", ";}", "{font-size:", ";}", "{width:", ";height:", ";}", "{font-size:", ";}}}"], _StyledSelect.StyledSelect, _StyledSelect.StyledSelection, function (props) {
  return props.theme.button.size.xsmall.height;
}, _StyledSelect.StyledSelectionChoice, function (props) {
  return props.theme.button.size.xsmall.height;
}, function (props) {
  return props.theme.button.size.xsmall.height;
}, _StyledSelect.StyledSelectionRendered, function (props) {
  return props.theme.button.size.xsmall.height;
}, function (props) {
  return props.theme.button.size.xsmall.borderWidth;
}, _StyledSelect.StyledSelectionClear, function (props) {
  return props.theme.button.size.xsmall.height;
}, function (props) {
  return props.theme.table.small.input.iconSize;
}, _StyledSelect.StyledArrow, function (props) {
  return props.theme.table.small.input.iconSize;
}, _StyledSelect.CopyButton, function (props) {
  return props.theme.button.size.xsmall.height;
}, function (props) {
  return props.theme.button.size.xsmall.height;
}, _StyledSelect.CopyIcon, function (props) {
  return props.theme.button.size.xsmall.fontSize;
});
var xSmallDatePicker = (0, _ykbStyledComponents.css)(["", "{&.table-xs{font-size:", ";height:", ";", "{align-items:center;", "{line-height:calc( ", " - 2 * ", " );height:calc( ", " - 2 * ", " );}}", "{svg{font-size:", ";}}", "{svg{font-size:", ";}}", "{svg{font-size:", ";}}}}"], _StyledDatePicker.StyledDatePicker, function (props) {
  return props.theme.button.size.xsmall.fontSize;
}, function (props) {
  return props.theme.button.size.xsmall.height;
}, _StyledTextInput.StyledInputWrapper, _StyledTextInput.StyledInput, function (props) {
  return props.theme.button.size.xsmall.height;
}, function (props) {
  return props.theme.button.size.xsmall.borderWidth;
}, function (props) {
  return props.theme.button.size.xsmall.height;
}, function (props) {
  return props.theme.button.size.xsmall.borderWidth;
}, _StyledDatePicker.StyledCalendarIcon, function (props) {
  return props.theme.table.small.input.iconSize;
}, _StyledDatePicker.StyledTimeIcon, function (props) {
  return props.theme.table.small.input.iconSize;
}, _StyledDatePicker.StyledClearIcon, function (props) {
  return props.theme.table.small.input.iconSize;
});
var xSmallNumericInput = (0, _ykbStyledComponents.css)(["", "{&.table-xs{", "{", "{font-size:", ";}}", "{", "{font-size:", ";}}", "{", "{font-size:", ";}}}}"], _StyledNumericInput.StyledNumericInputContainer, _StyledNumericInput.NumberInputControlButtonUp, _StyledIcon.default, function (props) {
  return props.theme.icon.size.xsmall.fontSize;
}, _StyledNumericInput.NumberInputControlButtonDown, _StyledIcon.default, function (props) {
  return props.theme.icon.size.xsmall.fontSize;
}, _StyledNumericInput.MobileControlButton, _StyledIcon.default, function (props) {
  return props.theme.icon.size.xsmall.fontSize;
});
var xSmallViewMode = (0, _ykbStyledComponents.css)(["", "{&.table-xs{min-height:", ";height:", ";padding:", ";line-height:calc( ", " - 2 * ", " );}}"], _StyledInputHoc.StyledViewModeValue, function (props) {
  return props.theme.button.size.xsmall.height;
}, function (props) {
  return props.theme.button.size.xsmall.height;
}, function (props) {
  return props.theme.button.size.xsmall.padding;
}, function (props) {
  return props.theme.button.size.xsmall.height;
}, function (props) {
  return props.theme.button.size.xsmall.borderWidth;
});
var tableHeaderXsmallComponents = (0, _ykbStyledComponents.css)(["", ";"], xSmallTableHeaderGhostButton);
var tableXsmallComponents = exports.tableXsmallComponents = (0, _ykbStyledComponents.css)(["", ";", ";", ";", ";", ";", ";", ";"], xSmallButton, xSmallInput, xSmallSelect, xSmallDatePicker, xSmallNumericInput, xSmallViewMode, tableHeaderXsmallComponents);